import { C_ACTION } from '../constans';

export const ui = (state = {}, action) => {
  switch (action.type) {
    case C_ACTION.UI_CHANGE_SELECT_PROVIDER: {
      return { ...state, selectProvider: action.data };
    }
    case C_ACTION.UI_CHANGE_WB_VIEW_SIZE: {
      return { ...state, is_check_size: action.data };
    }
    case C_ACTION.UI_CHANGE_SHIPMENT_MODE: {
      return { ...state, shipment_mode: action.data };
    }

    case C_ACTION.UI_CHANGE_SKLADNAME: {
      return { ...state, skladName: action.data };
    }

    case C_ACTION.UI_CHANGE_SKLADNAME: {
      return { ...state, skladName: action.data };
    }

    case C_ACTION.UI_USERS_AVATARS: {
      return { ...state, users_avatars: action.data };
    }

    default:
      return state;
  }
};
